import React, { useState, useEffect } from 'react';
import Fade from '@mui/material/Fade';

function FadeWrapper({ children }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <Fade in={show} timeout={500}>
      <div>
        {children}
      </div>
    </Fade>
  );
}

export default FadeWrapper;
